import React, { useEffect, useCallback } from 'react';
import styled from 'libs/styled';
import useAppDispatch from '@fogia/core-web/hooks/useAppDispatch';
import { show as showOverlay } from '@fogia/core-web/state/application/overlay';

const PLANNER_ORIGIN = 'https://planner.fogia.com';

const Wrapper = styled('div')`
    width: 100%;
    padding: 0 var(--grid-padding, 10px);
`;

const Iframe = styled('iframe')`
    aspect-ratio: 16 / 9;
    width: 100%;
    border: none;
`;

const Configurator: React.FC = () => {
    const dispatch = useAppDispatch();

    const handleMessage = useCallback(
        (event: MessageEvent) => {
            if (event.origin !== PLANNER_ORIGIN) {
                return;
            }

            if (event.data?.type === 'custom:quote') {
                dispatch(showOverlay({ view: 'quoteOverlay', transition: 'from-right', data: {} }));
            } else if (event.data?.type === 'custom:pdf') {
                const { detail } = event.data;
                if (detail?.configuration?.image && Array.isArray(detail?.items)) {
                    import('./generateConfiguratorPdf').then(({ default: generateConfiguratorPdf }) => {
                        generateConfiguratorPdf(detail);
                    });
                }
            }
        },
        [dispatch],
    );

    useEffect(() => {
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [handleMessage]);

    return (
        <Wrapper>
            <Iframe
                title="Configurator"
                frameBorder="0"
                allowFullScreen
                allow="clipboard-write; fullscreen"
                loading="lazy"
                src={`${PLANNER_ORIGIN}/?iframe=1`}
            />
        </Wrapper>
    );
};

export default Configurator;
